/* Aristosil theme, product page behaviour. Ported Mon 19 Oct 2026 (stage 2) from the approved static site's
   js/product.js (design v5) onto window.ARISTOSIL, which assets/aris-main.js builds on Shopify's Ajax cart.
   Class names and data attributes are the static page's. Copy the merchant can see comes from data attributes the
   sections print (theme editor settings); the few fallbacks below are the static words.

   Per-product data: <script type="application/json" id="product-data"> (sections/aris-pdp-main.liquid) carries
   { handle, name, price, finish, category, gender, categoryHref, size, soldOut, variantId, barOnly, crumbs } (PDP pass
   27 Oct 2026, C11: the card files come from A.catalogue, the picks are Liquid's). No demo content: recently viewed
   shows only this visitor's own history (A.recent).

   PDP pass 27 Oct 2026: the phone gallery peeks the next frame and carries dots (C04); the sticky bar comes on once
   the buy row has passed under the header on every width and Buy now is a native submit (C01); Add both is a real
   form intercepted here (C02); the ask form is Shopify's contact form (C08); the pincode prints no arrival range
   while the courier gate is off (C09).

   PDP pass 1 Nov 2026 (docs/qc/pdp-pass-2026-11-01/NOTES.md): the desktop gallery is a thumb rail and one stage at
   every frame count (the two-across stack is gone, so the .gal__more openers went with it); the rail scrolls its
   current thumb into view; the bands under the buy column rise as they enter (IntersectionObserver with a 2.5 s
   safety that shows everything, and nothing on the first screen is touched).

   Not here, on purpose: the Add to cart forms (form[data-add] inside [data-product], the column and the sticky bar)
   and the hearts, tabs and [data-wa] links are aris-main.js's. The pay line, the cash on delivery words, the EMI
   floor and the gated rows are decided in Liquid from Theme settings > Aristosil: gates.

   Everything is an enhancement. With JS off the page is complete: the gallery scrolls by snap and its thumbnails are
   anchors, each photo opens its large file, the guides open by :target with both methods shown, the accordions are
   native <details>, Add to cart posts to /cart/add, the pincode form posts to the shipping page.
   Banned here as everywhere: urgency, invented counts, IntersectionObserver for the sticky bar. */
(function () {
  'use strict';
  var A = window.ARISTOSIL;
  var doc = document;
  var buy = doc.querySelector('.buy[data-product]');
  if (!A || !buy) return;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function attr(el, name, fb) { var v = el && el.getAttribute(name); return v == null || v === '' ? fb : v; }
  function waHref(text) {
    if (typeof A.waHref === 'function') return A.waHref(text);
    return 'https://wa.me/' + ((A.whatsapp && A.whatsapp.number) || '') + '?text=' + encodeURIComponent(text);
  }
  function icon(id) { return '<svg class="ico ico--s" aria-hidden="true"><use href="#' + id + '"/></svg>'; }
  function inr(n) { return typeof A.inr === 'function' ? A.inr(n) : (A.currency || '₹') + Math.round(n).toLocaleString('en-IN'); }
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mqDesk = window.matchMedia ? matchMedia('(min-width: 900px)') : { matches: true };
  var mqCoarse = window.matchMedia ? matchMedia('(pointer: coarse)') : { matches: false };
  function onMq(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  var DATA = null;
  var dataEl = doc.getElementById('product-data');
  if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (e) { DATA = null; } }
  DATA = DATA || {};
  var P = {
    h: buy.getAttribute('data-handle'), n: buy.getAttribute('data-name'), p: +buy.getAttribute('data-price'),
    f: buy.getAttribute('data-finish') || '', img: buy.getAttribute('data-img') || '',
    id: +(buy.getAttribute('data-variant-id') || DATA.variantId || 0) || undefined
  };
  var SIZE_TEXT = DATA.size || '';
  // C10: the buy bar as the single buy control (section switch, off by default)
  var BAR_ONLY = !!DATA.barOnly;
  function qtyMax(el) { return Math.max(1, +(el && el.getAttribute('max')) || 5); }

  /* ---------- J05 Funnel event: view_item to window.dataLayer, the real price and handle; no script, no ids ---------- */
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'view_item', ecommerce: { currency: 'INR', value: P.p, items: [{ item_id: String(P.id || P.h), item_handle: P.h, item_name: P.n, item_category: DATA.category || '', item_variant: SIZE_TEXT, price: P.p, quantity: 1 }] } });

  /* ---------- A01 Breadcrumb: arriving from Men, Women, Gifts or a named collection that lists this piece, the
     middle crumb names that grid, so Back returns the buyer to it. The schema keeps the category. ---------- */
  (function () {
    var mid = $('[data-crumb-mid]', buy);
    if (!mid || !DATA.crumbs || !doc.referrer) return;
    try {
      var r = new URL(doc.referrer);
      if (r.origin !== location.origin) return;
      var m = r.pathname.match(/^\/collections\/([a-z0-9-]+)\/?$/);
      var c = m && DATA.crumbs[m[1]];
      if (!c) return;
      mid.textContent = c.name;
      mid.href = c.href + (r.search || '');
    } catch (e) { /* old browser: the category crumb stays */ }
  })();

  /* ---------- A02 Gallery: snap track, thumbnails, arrows, keyboard; the zoom hint says Tap on a touch screen ---------- */
  var WORD_TAP = attr(buy, 'data-zoom-tap', 'Tap'), WORD_CLICK = attr(buy, 'data-zoom-click', 'Click');
  function zoomWord() { $all('[data-zoom-word]').forEach(function (el) { el.textContent = mqCoarse.matches ? WORD_TAP : WORD_CLICK; }); }
  zoomWord();
  onMq(mqCoarse, zoomWord);
  var gal = $('[data-gallery]');
  var track = gal && $('[data-gal-track]', gal);
  var slides = gal ? $all('.gal__slide', gal) : [];
  var thumbs = gal ? $all('[data-gal-thumb]', gal) : [];
  var dots = gal ? $all('[data-gal-dot]', gal) : [];
  var galN = gal && $('[data-gal-n]', gal);
  var cur = 0;
  function setCur(i) {
    cur = i;
    if (galN) galN.textContent = String(i + 1);
    thumbs.forEach(function (t, k) {
      if (k === i) {
        t.setAttribute('aria-current', 'true');
        // the rail keeps the current thumb in view without moving the page
        var rail = t.closest('.gal__thumbs');
        if (rail && rail.scrollHeight > rail.clientHeight) {
          var top = t.offsetTop - rail.offsetTop, bottom = top + t.offsetHeight;
          if (top < rail.scrollTop) rail.scrollTo({ top: top - 8, behavior: reduce ? 'auto' : 'smooth' });
          else if (bottom > rail.scrollTop + rail.clientHeight) rail.scrollTo({ top: bottom - rail.clientHeight + 8, behavior: reduce ? 'auto' : 'smooth' });
        }
      } else { t.removeAttribute('aria-current'); }
    });
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    $all('video', gal).forEach(function (v) { if (!v.paused) v.pause(); });
  }
  // the slides peek on phones (C04), so a slide's scroll position is its own offset, not a multiple of the track width
  function slideLeft(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
  function nearest() {
    var x = track.scrollLeft, best = 0, d = Infinity;
    for (var k = 0; k < slides.length; k++) { var dd = Math.abs(slideLeft(k) - x); if (dd < d) { d = dd; best = k; } }
    return best;
  }
  function go(i, instant) {
    if (!track || !slides.length) return;
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slideLeft(i), behavior: (reduce || instant) ? 'auto' : 'smooth' });
    setCur(i);
  }
  if (track) {
    var galTick = false;
    track.addEventListener('scroll', function () {
      if (galTick) return;
      galTick = true;
      requestAnimationFrame(function () {
        galTick = false;
        var i = nearest();
        if (i !== cur && i >= 0 && i < slides.length) setCur(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function (e) { e.preventDefault(); go(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function (e) { e.preventDefault(); go(k); }); });
    $all('[data-gal-step]', gal).forEach(function (b) {
      b.hidden = false;
      b.addEventListener('click', function () { go(cur + (+b.getAttribute('data-gal-step'))); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if ((e.key === 'Enter' || e.key === ' ') && e.target === track) { e.preventDefault(); openLb(cur, track); }
    });
    window.addEventListener('resize', function () { track.scrollLeft = slideLeft(cur); });
  }

  /* ---------- A02 Lightbox: opens by click, tap or Enter; Esc closes; focus returns ---------- */
  var lb = $('[data-lb]');
  var lbStage = lb && $('[data-lb-stage]', lb);
  var lbN = lb && $('[data-lb-n]', lb);
  var ZOOM_IN = attr(lb, 'data-zoom-in', 'Zoom in'), ZOOM_OUT = attr(lb, 'data-zoom-out', 'Zoom out');
  // the track's anchors are the slides
  var openers = $all('.gal__track [data-gal-open]');
  var lbAt = {};   // data-gal-open index (media position) to its place in photos (video media carry no anchor)
  openers.forEach(function (a, k) { lbAt[a.getAttribute('data-gal-open')] = k; });
  var photos = openers.map(function (a) {
    var im = a.querySelector('img');
    return { src: a.getAttribute('data-large'), w: +a.getAttribute('data-large-w'), h: +a.getAttribute('data-large-h'), alt: im ? im.alt : '' };
  });
  var li = 0;
  var lbOpener = null;
  function lbShow(i) {
    li = (i + photos.length) % photos.length;
    var ph = photos[li];
    lbStage.classList.remove('is-zoomed');
    lbStage.innerHTML = '<button class="lb__img" type="button" aria-label="' + esc(ZOOM_IN) + '"><img src="' + esc(ph.src) + '" width="' + ph.w + '" height="' + ph.h + '" alt="' + esc(ph.alt) + '"></button>';
    lbStage.scrollTop = 0; lbStage.scrollLeft = 0;
    if (lbN) lbN.textContent = String(li + 1);
  }
  function openLb(i, from) {
    if (!lb || typeof lb.showModal !== 'function' || !photos.length) return false;
    lbOpener = from || doc.activeElement;
    lbShow(Math.min(i, photos.length - 1));
    lb.showModal();
    doc.body.classList.add('has-dialog');
    var b = $('.lb__img', lb);
    if (b) b.focus({ preventScroll: true });
    return true;
  }
  function zoom(e) {
    var btn = $('.lb__img', lbStage);
    var img = btn && btn.querySelector('img');
    if (!img) return;
    if (lbStage.classList.contains('is-zoomed')) {
      lbStage.classList.remove('is-zoomed');
      img.style.width = '';
      btn.setAttribute('aria-label', ZOOM_IN);
      return;
    }
    var r = img.getBoundingClientRect();
    var fx = (e && e.clientX && r.width) ? (e.clientX - r.left) / r.width : 0.5;
    var fy = (e && e.clientY && r.height) ? (e.clientY - r.top) / r.height : 0.5;
    var W = Math.round(Math.max(photos[li].w || 0, r.width * 2.2));
    lbStage.classList.add('is-zoomed');
    img.style.width = W + 'px';
    var H = W * (photos[li].h / photos[li].w);
    lbStage.scrollLeft = Math.max(0, fx * W - lbStage.clientWidth / 2);
    lbStage.scrollTop = Math.max(0, fy * H - lbStage.clientHeight / 2);
    btn.setAttribute('aria-label', ZOOM_OUT);
  }
  if (lb && lbStage) {
    openers.forEach(function (a, k) {
      a.addEventListener('click', function (e) { if (openLb(k, a)) e.preventDefault(); });
    });
    lbStage.addEventListener('click', function (e) { if (e.target.closest('.lb__img')) zoom(e); });
    $all('[data-lb-step]', lb).forEach(function (b) { b.addEventListener('click', function () { lbShow(li + (+b.getAttribute('data-lb-step'))); }); });
    $all('[data-lb-close]', lb).forEach(function (b) { b.addEventListener('click', function () { lb.close(); }); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); lbShow(li + 1); var b = $('.lb__img', lb); if (b) b.focus({ preventScroll: true }); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); lbShow(li - 1); var c = $('.lb__img', lb); if (c) c.focus({ preventScroll: true }); }
    });
    lb.addEventListener('close', function () {
      doc.body.classList.remove('has-dialog');
      lbStage.innerHTML = '';
      go(li, true);
      if (lbOpener && lbOpener.focus) lbOpener.focus({ preventScroll: true });
    });
  }

  /* ---------- A04 Save beside the name: aris-main.js toggles the heart (A.wish); the line under it says where it went ---------- */
  var wishBtn = $('.buy__wish', buy);
  var savedMsg = $('[data-saved-msg]', buy);
  if (wishBtn && savedMsg && A.wish) {
    wishBtn.addEventListener('click', function () {
      setTimeout(function () {
        if (A.wish.has(P.h)) {
          var shopAll = (A.routes && A.routes.shopAll) || '/collections/all';
          savedMsg.innerHTML = esc(attr(savedMsg, 'data-saved-text', 'Saved on this device.')) + ' <a class="link" href="' + esc(shopAll) + '" data-saved-open>' + esc(attr(savedMsg, 'data-saved-link', 'See saved pieces')) + '</a>';
        } else {
          savedMsg.textContent = attr(savedMsg, 'data-removed-text', 'Removed from your saved pieces.');
        }
      }, 0);
    });
    savedMsg.addEventListener('click', function (e) {
      var a = e.target.closest('[data-saved-open]');
      if (a && A.drawer && A.drawer.open('wishlist', a)) e.preventDefault();
    });
  }

  /* ---------- A07 Size: the selected value shown as text, here, in the bar and on the cart line (data-size).
     A09 (gated "sizes", no data yet): a size marked data-sold stays tappable and turns the button into Sold out. ---------- */
  var bar = $('[data-buybar]');
  var atc = $('[data-atc]', buy);
  var atcLabel = atc ? atc.innerHTML : '';
  function syncSize() {
    var r = $('input[name="size"]:checked', buy);
    if (!r) return;
    var t = r.getAttribute('data-size-text') || r.value;
    SIZE_TEXT = t;
    $all('[data-size-out]').forEach(function (el) { el.textContent = t; });
    buy.setAttribute('data-size', t);
    if (bar) bar.setAttribute('data-size', t);
    if (atc && !DATA.soldOut) {
      var sold = r.hasAttribute('data-sold');
      atc.disabled = sold;
      atc.innerHTML = sold ? esc(attr(r, 'data-sold', 'Sold out in ' + t)) : atcLabel;
    }
  }
  $all('input[name="size"]', buy).forEach(function (r) { r.addEventListener('change', syncSize); });
  syncSize();

  /* ---------- C01 Quantity, clamped 1 to the input's max (5), mirrored into the bar ---------- */
  var qIn = $('.qty__in', buy);
  var qMirror = $('[data-qty-mirror]');
  var qMinus = $('[data-step="-1"]', buy);
  var qPlus = $('[data-step="1"]', buy);
  var QMAX = qtyMax(qIn);
  function setQty(v) {
    v = Math.max(1, Math.min(QMAX, Math.round(+v) || 1));
    qIn.value = v;
    if (qMinus) qMinus.disabled = v <= 1;
    if (qPlus) qPlus.disabled = v >= QMAX;
    if (qMirror) qMirror.value = v;
  }
  var bqIn = bar && $('[data-bar-qty]', bar);
  var bqMinus = bar && $('[data-bar-step="-1"]', bar);
  var bqPlus = bar && $('[data-bar-step="1"]', bar);
  var setQtyAll = function (v) {
    setQty(v);
    v = +qIn.value;
    if (bqIn) bqIn.value = v;
    if (bqMinus) bqMinus.disabled = v <= 1;
    if (bqPlus) bqPlus.disabled = v >= QMAX;
  };
  if (qIn && !DATA.soldOut) {
    $all('[data-step]', buy).forEach(function (b) {
      b.addEventListener('click', function () { setQtyAll(+qIn.value + (+b.getAttribute('data-step'))); });
    });
    qIn.addEventListener('change', function () { setQtyAll(qIn.value); });
    if (bar) {
      $all('[data-bar-step]', bar).forEach(function (b) {
        b.addEventListener('click', function () { setQtyAll(+qIn.value + (+b.getAttribute('data-bar-step'))); });
      });
      if (bqIn) bqIn.addEventListener('change', function () { setQtyAll(bqIn.value); });
    }
    setQtyAll(qIn.value);
  }

  /* ---------- A08 Guides: ring, wrist (bracelets, kadas) and chain, each a native dialog with two method tabs.
     Opened from the size row and the links; a link to #size-guide, #wrist-guide or #chain-guide (the JS-off route)
     opens the modal instead. Focus returns to what opened it. Only dialogs: the phone menu sheet is aris-menu.js's. ---------- */
  var sheets = {};
  $all('dialog[data-sheet]').forEach(function (s) { sheets[s.id] = s; });
  var sheetOpener = null;
  var KIND = { ring: 'size-guide', wrist: 'wrist-guide', chain: 'chain-guide' };
  function openSheet(id, from) {
    var s = sheets[id];
    if (!s || typeof s.showModal !== 'function') return false;
    sheetOpener = from || null;
    s.showModal();
    doc.body.classList.add('has-dialog');
    var body = $('.sheet__body', s);
    if (body) body.scrollTop = 0;
    return true;
  }
  $all('[data-open-guide]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (openSheet(KIND[a.getAttribute('data-open-guide')], a)) e.preventDefault(); });
  });
  Object.keys(sheets).forEach(function (id) {
    var s = sheets[id];
    $all('[data-sheet-close]', s).forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); s.close(); }); });
    s.addEventListener('click', function (e) { if (e.target === s) s.close(); });
    s.addEventListener('close', function () {
      doc.body.classList.remove('has-dialog');
      if (sheetOpener && sheetOpener.focus) sheetOpener.focus({ preventScroll: true });
    });
    // method tabs: one panel at a time, arrow keys move
    var tabs = $all('[data-sheet-tab]', s), panels = $all('[data-sheet-panel]', s);
    function showTab(k, focus) {
      tabs.forEach(function (t, j) { var on = j === k; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
      panels.forEach(function (p, j) { p.hidden = j !== k; });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { showTab(k); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        showTab((k + d + tabs.length) % tabs.length, true);
      });
    });
    if (tabs.length) showTab(0);
    var printBtn = $('[data-print-sizer]', s);
    if (printBtn && typeof window.print === 'function') {
      printBtn.hidden = false;
      printBtn.addEventListener('click', function () { doc.body.classList.add('is-printing-sizer'); window.print(); });
      window.addEventListener('afterprint', function () { doc.body.classList.remove('is-printing-sizer'); });
    }
  });
  var hashId = location.hash.slice(1);
  if (sheets[hashId]) {
    if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
    openSheet(hashId, null);
  }

  /* ---------- "Conditions" opens Shipping and returns; D07 "Ask a question" goes to the question field ---------- */
  function openAcc(id) {
    var d = doc.getElementById(id);
    if (!d) return false;
    d.open = true;
    d.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    var s = d.querySelector('summary');
    if (s) s.focus({ preventScroll: true });
    return true;
  }
  $all('[data-open-acc]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (openAcc(a.getAttribute('data-open-acc'))) e.preventDefault(); });
  });
  var askBox = $('[data-qa-ask]');
  $all('[data-ask]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var q = doc.getElementById('qa-q');
      if (!q || !askBox) return;
      e.preventDefault();
      askBox.open = true;
      askBox.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      q.focus({ preventScroll: true });
    });
  });

  /* ---------- D08 Share: the system share sheet where there is one, else copy the link ---------- */
  var shareBtn = $('[data-share]');
  var shareMsg = $('[data-share-msg]');
  if (shareBtn && shareMsg) {
    shareBtn.hidden = false;
    shareBtn.addEventListener('click', function () {
      var url = location.href.split('#')[0].split('?')[0];
      if (navigator.share) { navigator.share({ title: P.n + ' | ' + (doc.title.split(' | ').pop() || ''), url: url }).catch(function () { /* closed */ }); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { shareMsg.textContent = attr(shareBtn, 'data-copied', 'Link copied.'); }, function () { shareMsg.textContent = url; });
      } else { shareMsg.textContent = url; }
    });
  }

  /* ---------- D01 Delivery date by pincode: a window, never a duration (audit 26), from A.delivery (aris-main.js:
     1 working day to dispatch plus transit, to 2 plus transit). Remembered on this device (aristosil-pin) and shown
     again on load with Change, here, on every product page and in the side cart. ---------- */
  var pinForm = $('[data-pin]');
  var D = A.delivery;
  if (pinForm && D) {
    var pinIn = $('input', pinForm);
    var pinOut = $('[data-pin-out]', pinForm);
    var fmt = typeof A.fmtDate === 'function' ? A.fmtDate : function (d) { return String(d); };
    var showPin = function (v) {
      var w = D.window(v);
      if (!w) return;
      pinIn.value = v;
      pinForm.classList.add('is-known');
      var dispatch = w.dispatch ? fmt(w.dispatch) : attr(pinForm, 'data-dispatch', '');
      var t;
      if (w.early && pinForm.getAttribute('data-courier') === 'on') {
        t = esc(attr(pinForm, 'data-arrives', 'Arrives between [early] and [late] at [pin], if you order today. Dispatched by [dispatch].'));
        t = t.replace('[early]', '<strong>' + esc(fmt(w.early)) + '</strong>').replace('[late]', '<strong>' + esc(fmt(w.late)) + '</strong>');
      } else {
        // courier gate off (C09): the pincode is confirmed and the real dispatch date printed, no arrival range
        t = esc(attr(pinForm, 'data-known', 'Dispatched by [dispatch], if you order today.'));
      }
      t = t.replace('[pin]', esc(v)).replace('[dispatch]', '<strong>' + esc(dispatch) + '</strong>');
      pinOut.innerHTML = t + ' <button class="pin__change" type="button" data-pin-change>' + esc(attr(pinForm, 'data-change', 'Change')) + '<span class="vh"> pincode</span></button>';
    };
    var pinError = function () {
      pinForm.classList.remove('is-known');
      pinIn.setAttribute('aria-invalid', 'true');
      pinOut.classList.add('is-error');
      pinOut.textContent = attr(pinForm, 'data-bad', 'Enter a 6-digit pincode, for example 530020.');
      pinIn.focus();
    };
    pinIn.addEventListener('input', function () {
      var v = pinIn.value.replace(/\D/g, '').slice(0, 6);
      if (v !== pinIn.value) pinIn.value = v;
      if (pinIn.getAttribute('aria-invalid') === 'true') { pinIn.removeAttribute('aria-invalid'); pinOut.classList.remove('is-error'); }
    });
    pinForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = pinIn.value.trim();
      if (!D.valid(v)) { pinError(); return; }
      pinIn.removeAttribute('aria-invalid');
      pinOut.classList.remove('is-error');
      D.set(v);
      showPin(v);
    });
    pinOut.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pin-change]')) return;
      pinForm.classList.remove('is-known');
      pinIn.focus();
      pinIn.select();
    });
    var known = D.get();
    if (known) showPin(known);
    doc.addEventListener('aristosil:pin', function (e) { if (e.detail && e.detail.pin && e.detail.pin !== pinIn.value) showPin(e.detail.pin); });
  }

  /* ---------- C07 Sold out with back-in-stock (PDP pass, C08): Notify me checks the email for shape, then the
     Shopify customer form posts natively (contact[tags] restock,<handle>), so the address reaches the store's
     customers list; the thanks line is Liquid's after the post. ---------- */
  var soldout = $('[data-soldout]');
  if (soldout) {
    DATA.soldOut = true;
    if (atc) atc.disabled = true;
    if (qIn) { qIn.disabled = true; if (qMinus) qMinus.disabled = true; if (qPlus) qPlus.disabled = true; }
    $all('input[name="size"]', buy).forEach(function (r) { r.disabled = true; });
    var nForm = $('form', soldout), nIn = $('input[type="email"]', soldout), nMsg = $('.soldout__msg', soldout);
    var notify = function (e) {
      var v = (nIn.value || '').trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      nIn.setAttribute('aria-invalid', String(!ok));
      if (nMsg) { nMsg.classList.toggle('is-error', !ok); nMsg.textContent = ok ? '' : attr(soldout, 'data-bad-email', 'Enter an email address, for example name@example.com.'); }
      if (!ok) { if (e) e.preventDefault(); nIn.focus(); }
    };
    if (nForm) nForm.addEventListener('submit', notify);
    var bn = bar && $('[data-bar-notify]', bar);
    if (bn && nIn) bn.addEventListener('click', function () {
      soldout.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      nIn.focus({ preventScroll: true });
    });
  }

  /* ---------- B05 Copy code (renders only with a real code): Copied for 1.6 s, announced; JS off: selectable text ---------- */
  $all('[data-copy-code]').forEach(function (b) {
    var msg = $('[data-copy-msg]', b.closest('[data-offer]') || doc);
    var label = b.textContent;
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-copy-code');
      var done = function () {
        b.textContent = attr(b, 'data-copied', 'Copied');
        b.classList.add('is-copied');
        if (msg) msg.textContent = attr(b, 'data-copied-msg', 'Code [code] copied').replace('[code]', code);
        setTimeout(function () { b.textContent = label; b.classList.remove('is-copied'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, function () { if (msg) msg.textContent = code; });
    });
  });

  /* ---------- C05 the error line with the WhatsApp route, for Buy now (the form's own add is aris-main.js's) ---------- */
  var addErr = $('[data-add-error]', buy);
  function showAddError() {
    if (!addErr) return;
    var q = attr(addErr, 'data-error-wa', 'Hi, I would like to order the [name]').replace('[name]', P.n) + (SIZE_TEXT ? ' (' + SIZE_TEXT + ')' : '');
    var addErrTxt = attr(addErr, 'data-error-text', 'That did not go through. Try again, or');
    addErr.innerHTML = (A.whatsapp && A.whatsapp.number) ? esc(addErrTxt) + ' <a class="link" href="' + esc(waHref(q)) + '" target="_blank" rel="noopener">' + esc(attr(addErr, 'data-error-link', 'order on WhatsApp')) + '</a>.' : esc(addErrTxt.replace(/,?\s*or\s*$/, '')) + '.';
  }
  function item(q) { return { id: P.id, h: P.h, n: P.n, p: P.p, f: P.f, img: P.img, s: SIZE_TEXT, q: q || 1 }; }
  function addP(it, opts) {
    try { return Promise.resolve(A.cart.add(it, opts)); } catch (e) { return Promise.reject(e); }
  }

  /* ---------- C11 Buy now (Theme settings > gates > Buy now): a submit button on the Add to cart form with
     return_to=/checkout, in the column and in the bar; aris-main.js lets that submitter post natively and Shopify
     sends the buyer to checkout at the chosen quantity (the bar's hidden quantity mirrors the column's). Razorpay
     Magic Checkout (snippets/razorpay-magic-checkout.liquid) takes over the checkout from there. ---------- */
  $all('[data-buy-now]').forEach(function (b) { if (DATA.soldOut) b.hidden = true; });

  /* ---------- Sticky column (framework 7.A.2): the shorter column sticks; within 50 px, neither ---------- */
  var grid = $('.pdp-top__grid');
  function decideStick() {
    if (!grid || !gal) return;
    if (!mqDesk.matches) { grid.removeAttribute('data-stick'); A.pdpStick = { sticky: 'none (phone layout)' }; return; }
    var gh = gal.offsetHeight, bh = buy.offsetHeight, travel = Math.abs(bh - gh);
    var which = travel <= 50 ? 'none' : (gh < bh ? 'gal' : 'buy');
    grid.setAttribute('data-stick', which);
    A.pdpStick = { gallery: gh, buy: bh, travel: travel, sticky: which };
  }
  decideStick();
  window.addEventListener('load', decideStick);
  window.addEventListener('resize', decideStick);
  onMq(mqDesk, decideStick);
  buy.addEventListener('toggle', decideStick, true);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(decideStick);

  /* ---------- C08 C09 Sticky buy bar. Scroll-driven, rAF-throttled, synced on load and resize, never
     IntersectionObserver (framework 10.2). Phones: on whenever the in-column button row is out of view, above (under
     the header) or below (under the bar's own band). Desktop: on once the row has scrolled under the header. The page
     ends above the bar and the WhatsApp launcher lifts over it by the bar's measured height plus 12 px. ---------- */
  var row = $('.buy__row', buy);
  var hdr = $('[data-hdr]');
  if (BAR_ONLY) buy.classList.add('is-bar-only');
  if (bar && row) {
    var barTick = false;
    var buyNow = $('[data-buy-now]', buy);
    var measureBar = function () { doc.documentElement.style.setProperty('--aris-buybar-h', bar.offsetHeight + 'px'); };
    var syncBar = function () {
      barTick = false;
      var limit = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
      var r = (buyNow || row).getBoundingClientRect();
      // C01: on once the buy row's bottom has passed under the header, then to the end of the page, on every width;
      // never over the price and the size row on the first phone screen (this narrows the 16 Oct "on the whole
      // page" word for the first screen only)
      // v6, 2 Nov 2026 (Omkar: "clueless like product name and atc"): on phones the bar also shows while the row is
      // still below the screen, as Clueless's .mbar is on from the first phone screen; it steps aside while the
      // column's own buttons are in view. Desktop unchanged.
      // 3 Nov, Omkar: "dont show atc before it scroll passes the buy now". The v6 phone first-screen rule is gone;
      // on every width the bar waits until Buy now (or the buy row when Buy now is off) has passed under the header.
      var on = BAR_ONLY || r.bottom < limit;
      if (on === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', on);
      doc.body.classList.toggle('has-buybar', on);
      if (on) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
    };
    var queue = function () { if (!barTick) { barTick = true; requestAnimationFrame(syncBar); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { measureBar(); queue(); });
    onMq(mqDesk, function () { measureBar(); syncBar(); });
    window.addEventListener('load', function () { measureBar(); syncBar(); });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function () { measureBar(); syncBar(); });
    measureBar();
    syncBar();
    A.pdpBar = { sync: syncBar };
    var thumbBtn = $('[data-bar-gallery]', bar);
    if (thumbBtn) thumbBtn.addEventListener('click', function () {
      (gal || $('.pdp-top')).scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      if (track) track.focus({ preventScroll: true });
    });
  }

  /* ---------- F02 Add both (PDP pass, C02): one real form posting both variants to /cart/add (works with JS off);
     here it is intercepted, this piece and its pair added one after the other through the Ajax cart, then the side
     cart opens with "Both added to your cart." A refused add writes the error line under the bundle's own button,
     with the WhatsApp route. ---------- */
  var bothForm = $('[data-add-both-form]');
  var both = $('[data-add-both]');
  var bundle = $('[data-bundle]');
  var pairErr = $('[data-pair-error]');
  function showPairError() {
    if (!pairErr) return showAddError();
    var q = attr(pairErr, 'data-error-wa', 'Hi, I would like to order the [name]').replace('[name]', P.n);
    var pairErrTxt = attr(pairErr, 'data-error-text', 'That did not go through. Try again, or');
    pairErr.innerHTML = (A.whatsapp && A.whatsapp.number) ? esc(pairErrTxt) + ' <a class="link" href="' + esc(waHref(q)) + '" target="_blank" rel="noopener">' + esc(attr(pairErr, 'data-error-link', 'order on WhatsApp')) + '</a>.' : esc(pairErrTxt.replace(/,?\s*or\s*$/, '')) + '.';
    pairErr.hidden = false;
  }
  if (bothForm && both && bundle) {
    bothForm.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (both.classList.contains('is-done') || both.getAttribute('aria-busy') === 'true') return;
      both.setAttribute('aria-busy', 'true');
      if (pairErr) { pairErr.hidden = true; pairErr.innerHTML = ''; }
      var chain = addP(item(1), { quiet: true }).then(function () {
        return addP({ id: +bundle.getAttribute('data-variant-id') || undefined, h: bundle.getAttribute('data-handle'), n: bundle.getAttribute('data-name'), p: +bundle.getAttribute('data-price'), f: bundle.getAttribute('data-finish') || '', img: bundle.getAttribute('data-img') || '', q: 1 }, { quiet: true });
      });
      chain.then(function () {
        both.removeAttribute('aria-busy');
        if (A.cart.announce) A.cart.announce(attr(both, 'data-announce', 'Both added to your cart.'));
        var label = both.innerHTML;
        both.classList.add('is-done');
        both.innerHTML = icon('i-check') + esc(attr(both, 'data-done', 'Both added'));
        if (A.drawer) A.drawer.open('cart', both);
        setTimeout(function () { both.classList.remove('is-done'); both.innerHTML = label; }, 1600);
      }, function () {
        both.removeAttribute('aria-busy');
        showPairError();
      });
    });
  }

  /* ---------- G05 Questions (PDP pass, C08): the form is Shopify's contact form and posts natively to the store
     inbox; before it goes the question is checked for length and kept in this tab (sessionStorage) so the
     "Awaiting answer" row shows under the empty line until Aristosil posts the answer. ---------- */
  var qa = $('[data-qa]');
  if (qa) {
    var QKEY = 'aristosil-qa-' + P.h;
    var qaList = $('[data-qa-list]'), qaEmpty = $('[data-qa-empty]'), qaMsg = $('[data-qa-msg]', qa);
    var qaQ = $('textarea', qa), qaName = $('#qa-name', qa);
    var answered = !!$('.qa__ans');
    if (askBox && /contact_posted=true/.test(location.search)) { askBox.open = true; }
    var qget = function () { try { return JSON.parse(sessionStorage.getItem(QKEY)) || []; } catch (e) { return []; } };
    var qset = function (v) { try { sessionStorage.setItem(QKEY, JSON.stringify(v)); } catch (e) { /* the page still works */ } };
    var renderQ = function () {
      var qs = qget();
      if (qaEmpty) qaEmpty.hidden = answered || qs.length > 0;
      if (!qaList) return;
      var asked = attr(qaList, 'data-asked', 'Asked by [who], [date]'), you = attr(qaList, 'data-you', 'you'), wait = attr(qaList, 'data-awaiting', 'Awaiting answer');
      qaList.innerHTML = qs.map(function (q) {
        return '<li><p class="qa__q-text">' + esc(q.q) + '</p><p class="qa__meta">' + esc(asked.replace('[who]', q.n || you).replace('[date]', q.d)) + '</p><p class="chip qa__state">' + esc(wait) + '</p></li>';
      }).join('');
    };
    renderQ();
    qa.addEventListener('submit', function (e) {
      var q = (qaQ.value || '').trim();
      var em = $('#qa-email', qa);
      var okEmail = !em || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((em.value || '').trim());
      if (q.length < 10 || !okEmail) {
        e.preventDefault();
        qaQ.setAttribute('aria-invalid', String(q.length < 10));
        if (em) em.setAttribute('aria-invalid', String(!okEmail));
        qaMsg.classList.add('is-error');
        qaMsg.textContent = attr(qa, 'data-short', 'Write your question in a few words, at least 10 characters.');
        (q.length < 10 ? qaQ : em).focus();
        return;
      }
      qaQ.removeAttribute('aria-invalid');
      qaMsg.classList.remove('is-error');
      var qs = qget();
      qs.push({ q: q.slice(0, 600), n: (qaName.value || '').trim().slice(0, 40), d: typeof A.fmtDate === 'function' ? A.fmtDate(new Date()) : new Date().toDateString() });
      qset(qs);
      // the native post goes on: Shopify takes the message and returns with ?contact_posted=true, Liquid prints the thanks
    });
    qaQ.addEventListener('input', function () { if (qaQ.getAttribute('aria-invalid') === 'true') { qaQ.removeAttribute('aria-invalid'); qaMsg.classList.remove('is-error'); qaMsg.textContent = ''; } });
  }

  /* ---------- G02 Write a review: order number and email checked for shape; as on the static page it stores and
     sends nothing until a review tool is chosen. G03 (gated): the empty Reviews block's link opens this form. ---------- */
  var review = $('[data-review]');
  if (review) {
    var rvOrder = $('#rv-order', review), rvEmail = $('#rv-email', review), rvMsg = $('[data-review-msg]', review);
    review.addEventListener('submit', function (e) {
      e.preventDefault();
      var okOrder = (rvOrder.value || '').trim().length >= 3;
      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((rvEmail.value || '').trim());
      rvOrder.setAttribute('aria-invalid', String(!okOrder));
      rvEmail.setAttribute('aria-invalid', String(!okEmail));
      rvMsg.classList.toggle('is-error', !(okOrder && okEmail));
      if (!(okOrder && okEmail)) {
        rvMsg.textContent = attr(review, 'data-bad', 'Enter your order number and the email used for it.');
        (okOrder ? rvEmail : rvOrder).focus();
        return;
      }
      review.reset();
      rvOrder.removeAttribute('aria-invalid'); rvEmail.removeAttribute('aria-invalid');
      rvMsg.textContent = attr(review, 'data-thanks', 'Thank you. Your review is checked against your order before it appears here.');
    });
  }
  $all('[data-open-review]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var d = doc.getElementById('write-review');
      if (!d) return;
      e.preventDefault();
      d.open = true;
      d.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
      var o = doc.getElementById('rv-order');
      if (o) o.focus({ preventScroll: true });
    });
  });

  /* ---------- F07 Recently viewed: this visitor's own history (A.recent), hidden on a first visit, never the piece
     on screen, in-stock pieces only. The card is snippets/aris-card.liquid's markup, drawn from the range
     (A.catalogue) and the page's card files (DATA.cards). No demo pieces. ---------- */
  var DOT = { 'Silver': ['silver'], 'Rose gold polish': ['rose'], 'Gold polish': ['gold'], 'Silver and rose gold': ['silver', 'rose'] };
  var recent = $('[data-recent]');
  var recentList = $('[data-recent-list]');
  function setOf(files) { return files.map(function (f) { return f[0] + ' ' + f[1] + 'w'; }).join(', '); }
  function cardHtml(p) {
    var sizes = '(min-width: 1200px) 316px, (min-width: 900px) 25vw, 50vw';
    // C11: the 400 and 800 px card files from A.catalogue (i, i2, o, o2), no per-page card map
    var c = p.i ? [[p.i, 400]].concat(p.i2 ? [[p.i2, 800]] : []) : [];
    var o = p.o ? [[p.o, 400]].concat(p.o2 ? [[p.o2, 800]] : []) : [];
    var href = p.u || ('/products/' + p.h);
    var dots = (DOT[p.f] || []).map(function (d, k) { return '<span class="chip__dot chip__dot--' + d + (k ? ' chip__dot--pair' : '') + '" aria-hidden="true"></span>'; }).join('');
    var saved = A.wish && A.wish.has(p.h);
    var wishLabel = attr(recent, 'data-wish-label', 'Save [name]').replace('[name]', p.n);
    var addLabel = attr(recent, 'data-add-label', 'Add to cart');
    var addUrl = (A.routes && A.routes.cartAdd) || '/cart/add';
    var img0 = c.length ? c[0][0] : '';
    return '<li class="card" data-product data-handle="' + esc(p.h) + '" data-name="' + esc(p.n) + '" data-price="' + p.p + '" data-finish="' + esc(p.f || '') + '" data-img="' + esc(img0) + '" data-variant-id="' + esc(p.v || '') + '">' +
      '<a class="card__media" href="' + esc(href) + '" tabindex="-1" aria-hidden="true">' +
      (img0 ? '<img class="card__img" src="' + esc(img0) + '" srcset="' + esc(setOf(c)) + '" sizes="' + sizes + '" width="400" height="500" alt="" loading="lazy" decoding="async">' : '') +
      (o.length ? '<img class="card__alt" src="' + esc(o[0][0]) + '" srcset="' + esc(setOf(o)) + '" sizes="' + sizes + '" width="400" height="500" alt="" loading="lazy" decoding="async">' : '') +
      '</a><button class="wish" type="button" data-wish="' + esc(p.h) + '" aria-pressed="' + (saved ? 'true' : 'false') + '" aria-label="' + esc(wishLabel) + '"><svg class="ico" aria-hidden="true"><use href="#i-heart"/></svg></button>' +
      '<div class="card__body"><h3 class="card__name"><a href="' + esc(href) + '">' + esc(p.n) + '</a></h3><p class="card__price">' + inr(p.p) + '</p>' +
      (p.f ? '<p class="chip">' + dots + esc(p.f) + '</p>' : '') + '</div>' +
      '<form class="card__add" action="' + esc(addUrl) + '" method="post" data-add><input type="hidden" name="id" value="' + esc(p.v || '') + '"><input type="hidden" name="quantity" value="1"><button class="btn btn--secondary btn--block btn--card" type="submit">' + esc(addLabel) + '<span class="vh">, ' + esc(p.n) + '</span></button></form></li>';
  }
  if (recent && recentList && A.recent && A.catalogue) {
    var most = +(recent.getAttribute('data-most')) || 4;
    var seenH = A.recent.get() || [];
    var shown = [];
    seenH.forEach(function (h) {
      if (h === P.h || shown.length >= most) return;
      if (shown.some(function (x) { return x.h === h; })) return;
      var p = A.byHandle ? A.byHandle(h) : A.catalogue.filter(function (x) { return x.h === h; })[0];
      if (p && p.s) shown.push(p);
    });
    if (shown.length) {
      recentList.innerHTML = shown.map(cardHtml).join('');
      recent.hidden = false;
    }
    A.recent.push(P.h);
  }

  /* P7 scroll reveal removed 1 Nov 2026 (round 2 part 2, Omkar: no AI-feel scroll animations). */

  /* ---------- v6 scroll motion, 2 Nov 2026 (Omkar: "motion in section on pdp"). The sections under the buy column rise
     and fade in as they enter: each section's heading and blocks, the cards of a rail one after another (70 ms apart,
     four steps at most). Transform and opacity only (assets/aris-product.css P10). Only parts that start below the
     first screen are touched, so nothing visible on load moves; with no IntersectionObserver, reduced motion, or JS
     off nothing is hidden. Printing shows everything. ---------- */
  (function () {
    if (reduce || !('IntersectionObserver' in window)) return;
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    var items = [];
    function add(el, i) {
      if (!el || el.nodeType !== 1 || el.hidden || el.matches('script, style, template, [hidden]')) return;
      var top = el.getBoundingClientRect().top;
      if (top < vh) return;
      el.style.setProperty('--rv-d', Math.min(i, 4) * 70 + 'ms');
      items.push(el);
    }
    $all('.page-product .sec, .page-product .catband').forEach(function (sec) {
      if (sec.closest('.pdp-top, [role="dialog"], dialog, .buybar')) return;
      $all('.wrap', sec).forEach(function (w) {
        if (w.parentElement.closest('.wrap')) return;
        Array.prototype.forEach.call(w.children, function (k) {
          if (k.matches('.pair__grid, .piece__grid, .qa__grid')) { Array.prototype.forEach.call(k.children, function (c, i) { add(c, i); }); return; }
          var rail = k.matches('.cards') ? k : null;
          if (rail) { Array.prototype.slice.call(rail.children, 0, 8).forEach(function (c, i) { add(c, i); }); return; }
          add(k, 0);
        });
      });
    });
    if (!items.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        el.classList.add('is-in');
        // once settled, the part goes back to its plain styles (hover zooms and the rest win again)
        setTimeout(function () { el.classList.remove('rv', 'is-in'); el.style.removeProperty('--rv-d'); }, 1600);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    items.forEach(function (el) { el.classList.add('rv'); io.observe(el); });
    window.addEventListener('beforeprint', function () { items.forEach(function (el) { el.classList.add('is-in'); }); });
  })();
})();

/* 2 Nov, Omkar: "Silver / 92.5 silver: can these come below the header of the sticky". The bar carries the same
   finish, metal and stone line as the name block, copied from it so the two never disagree. */
(function () {
  var src = document.querySelector('.specs--head');
  var bar = document.querySelector('[data-buybar] .buybar__l1');
  if (!src || !bar || bar.parentNode.querySelector('.buybar__row2')) return;
  var ul = src.cloneNode(true);
  ul.className = 'buybar__specs';
  ul.removeAttribute('aria-label');
  ul.setAttribute('aria-hidden', 'true');
  var row = document.createElement('div');
  row.className = 'buybar__row2';
  row.appendChild(ul);
  var tax = bar.querySelector('.buybar__tax');   /* the tax line joins the polish and silver row (phone) */
  if (tax) row.appendChild(tax);
  bar.parentNode.insertBefore(row, bar.nextSibling);
})();
